import { resolveColorFillStyle, resolveTextFillStyle } from './colorFillUtils';
import { resolveShapeRadius } from './colorFillUtils';

export const MENU_TAB_VARIANT_OPTIONS = [
  { value: 'inherit', label: 'Défaut du menu' },
  { value: 'transparent', label: 'Transparent' },
  { value: 'solid', label: 'Bouton plein' },
];

export function resolveMenuTabDefaultVariant(menuProps) {
  return menuProps?.menuTabDefaultVariant === 'solid' ? 'solid' : 'transparent';
}

export function resolveMenuTabVariant(menuProps, tabKey) {
  const cfg = menuProps?.tabAppearances?.[tabKey];
  const v = cfg?.variant;
  if (v === 'solid' || v === 'transparent') return v;
  if (String(tabKey || '').startsWith('button:')) return 'solid';
  return resolveMenuTabDefaultVariant(menuProps);
}

function resolveMenuTabShapeCfg(cfg, menuProps) {
  const shape =
    cfg?.shape != null && cfg.shape !== ''
      ? cfg.shape
      : menuProps?.menuTabShape || 'rounded';
  const borderRadius =
    cfg?.borderRadius != null && cfg?.borderRadius !== ''
      ? Number(cfg.borderRadius)
      : Number(menuProps?.menuTabBorderRadius ?? 8);
  return { shape, borderRadius };
}

function menuTabExtraStyle(cfg, menuProps) {
  const out = {};
  const { shape, borderRadius } = resolveMenuTabShapeCfg(cfg, menuProps);
  if (shape === 'pill') {
    out.borderRadius = '9999px';
  } else if (shape === 'square') {
    out.borderRadius = '0px';
  } else {
    out.borderRadius = `${resolveShapeRadius(shape, borderRadius)}px`;
  }
  if (cfg?.fontSize) out.fontSize = `${cfg.fontSize}px`;
  if (cfg?.fontWeight) out.fontWeight = cfg.fontWeight;
  return out;
}

export function resolveMenuTabAppearance(menuProps, tabKey) {
  const variant = resolveMenuTabVariant(menuProps, tabKey);
  const cfg = menuProps?.tabAppearances?.[tabKey] || {};
  const extra = menuTabExtraStyle(cfg, menuProps);

  const menuTextFill =
    menuProps?.textColor || { mode: 'solid', color: '#111827', alpha: 1 };

  if (variant === 'solid') {
    const bgFill =
      cfg.backgroundColor ||
      menuProps?.menuTabSolidBackground ||
      { mode: 'solid', color: '#ffffff', alpha: 1 };
    const textFill =
      cfg.textColor ||
      menuProps?.menuTabSolidTextColor ||
      menuTextFill;

    return {
      variant: 'solid',
      className: 'wc-menu-tab wc-menu-tab--solid',
      style: {
        ...resolveColorFillStyle(bgFill, '#ffffff'),
        ...resolveTextFillStyle(textFill, '#111827'),
        ...extra,
      },
    };
  }

  const textFill = cfg.textColor || menuTextFill;

  return {
    variant: 'transparent',
    className: 'wc-menu-tab wc-menu-tab--transparent',
    style: {
      backgroundColor: 'transparent',
      ...resolveTextFillStyle(textFill, '#111827'),
      ...extra,
    },
  };
}
